import { Button } from '@iwoca/orion';
import { Plural, Trans } from '@lingui/react/macro';
import { DashboardSettings } from 'components/DashboardSettings/DashboardSettings';
import Skeleton from 'react-loading-skeleton';
import styles from './ResultsBar.module.css';
import { useResultsBar } from './useResultsBar.hook';

export const ResultsBar = () => {
  const {
    isLoading,
    dateRangeLabel,
    applicationCount,
    hasActiveQuery,
    canClearFilters,
    openDateRangeSettings,
    clearFilters,
  } = useResultsBar();

  return (
    <div className={styles.resultsBar}>
      <div className={styles.summary} id="results-bar">
        <div className={styles.counts}>
          {dateRangeLabel && (
            <>
              <Button
                variant="tertiary"
                className={styles.link}
                onClick={openDateRangeSettings}
                data-testid="date-range-link"
              >
                {dateRangeLabel}
              </Button>
              <span className={styles.separator} aria-hidden="true">
                •
              </span>
            </>
          )}
          {isLoading ? (
            <Skeleton
              width={100}
              height={14}
              borderRadius={10}
              // overriding base colour with hardcoded colour as no variable exists for this
              baseColor="#D9D9D9"
              containerClassName={styles.skeleton}
              containerTestId="results-count-skeleton"
            />
          ) : (
            <span data-testid="results-count">
              {applicationCount === 0 && hasActiveQuery && (
                <Trans>No matching applications</Trans>
              )}
              {applicationCount === 0 && !hasActiveQuery && (
                <Trans>No applications</Trans>
              )}
              {applicationCount > 0 && hasActiveQuery && (
                <>
                  <strong>{applicationCount}</strong>{' '}
                  <Plural
                    value={applicationCount}
                    one="matching application"
                    other="matching applications"
                  />
                </>
              )}
              {applicationCount > 0 && !hasActiveQuery && (
                <>
                  <strong>{applicationCount}</strong>{' '}
                  <Plural
                    value={applicationCount}
                    one="application"
                    other="applications"
                  />
                </>
              )}
            </span>
          )}
        </div>
        {canClearFilters && (
          <Button
            variant="tertiary"
            className={styles.link}
            onClick={clearFilters}
          >
            <Trans>Clear filters</Trans>
          </Button>
        )}
      </div>

      <DashboardSettings />
    </div>
  );
};
